var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 462.513 462.513",
    style: {
      enableBackground: "new 0 0 462.513 462.513"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_229_",
    d: "M385.894,204.222h-0.246c-26.398,0-47.875,21.477-47.875,47.876v65.98c0,4.212-3.427,7.638-7.639,7.638 H301.03V79.873C301.03,35.831,265.199,0,221.156,0c-44.042,0-79.873,35.831-79.873,79.873v86.585h-25.04 c-2.592,0-4.701-2.109-4.701-4.702v-50.728c0-23.03-18.736-41.766-41.767-41.766h-0.001c-22.624,0-41.03,18.407-41.03,41.032v73.086 c0,36.324,29.553,65.875,65.879,65.875h46.66v198.256c0,8.284,6.716,15,15,15H286.03c8.284,0,15-6.716,15-15v-25.8h49.871 c45.693,0,82.868-37.171,82.868-82.86v-86.755C433.769,225.699,412.292,204.222,385.894,204.222z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.270499c11ed60d7e95fc64569a866f95.svg";
export { ForwardRef as ReactComponent };